export enum LocationOptionAllValue {
  AllRegions = '-1',
  AllCountries = '-2',
  AllStates = '-3',
}
